import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }

import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { AppAuthService } from '@prodcard/core'
import AuthForm from './AuthForm.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthPage',
  props: {
    authService: {}
  },
  setup(__props: any) {



const email = ref('')
const route = useRoute()
const router = useRouter()

const login = async () => {
  if (!router) return

  await router.push({ path: (route.query?.redirect || '/citizens') as string })
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, { width: "500" }, {
    default: _withCtx(() => [
      _createVNode(AuthForm, {
        "auth-service": _ctx.authService,
        "onUpdate:email": _cache[0] || (_cache[0] = str => (email.value = str)),
        onLogin: login
      }, {
        links: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_link, {
              class: "text-disabled text-decoration-underline text-body-2",
              to: { path: '/password-reset', query: { redirect: _unref(route).query.redirect, email: email.value } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Забыли пароль? ")
              ]),
              _: 1
            }, 8, ["to"]),
            _createTextVNode("   "),
            _createVNode(_component_router_link, {
              class: "text-disabled text-decoration-underline text-body-2",
              to: { path: '/self-registration', query: { redirect: _unref(route).query.redirect } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Регистрация ")
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        _: 1
      }, 8, ["auth-service"])
    ]),
    _: 1
  }))
}
}

})